// Semantic Versioning, without a display prefix or surrounding whitespace.
const releaseVersionPattern = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

export function validateReleaseVersion(release: unknown): string {
  if (
    !release ||
    typeof release !== "object" ||
    Array.isArray(release) ||
    Object.keys(release).length !== 1 ||
    !("version" in release) ||
    typeof release.version !== "string" ||
    release.version.trim() !== release.version ||
    !releaseVersionPattern.test(release.version)
  ) {
    throw new Error(
      'Invalid release.json: expected only a "version" key containing a semantic version, for example "3.3.0".',
    );
  }

  return release.version;
}
